export enum ErrorMessage {
  commonError = 'Something went wrong. Please refresh the page and try again.',
  completeRequiredFields = 'Please complete all required fields.',
}
